// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"23":"6c0b9365aa919f817238","884":"a747ced5e12717b8004a"}[chunkId] + ".css";
};